import config from 'config'

import { AbstractService } from 'shared/services/AbstractService'
import getLogger from 'shared/logger'

export class MttUrlService extends AbstractService implements Services.IMttUrlService {
  /**
   * Request a localized URL given urlId from the MTT URL Service
   * @param locale
   * @param urlId
   */
  public async getSpecificUrl(locale: i18n.Locale, urlId: string): Promise<string> {
    const url = `v3/url/${config.tenant}/${locale}/${urlId}`

    try {
      const { data } = await this.api.get<VP.MTT.Url>(url, {
        params: {
          requestor: config.appName,
        },
      })

      return data.url
    } catch {
      return ''
    }
  }
}

export const UrlService = new MttUrlService(config.services.mttUrlService, getLogger)
